<template>
  <div>
    <page-header :title="$t('ai.ai_gateway')" />
    <page-body>
      <list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'AiGatewayIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'AiGatewayList',
    }
  },
}
</script>

<style>

</style>
